import { ArticleHeader } from './ArticleHeader';
import register from './register';

register(ArticleHeader);
